import { HatElement } from '@/components/hat-element.js';

class HatWelcome extends HatElement {
  constructor() {
    super();

    this.root.innerHTML = `
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
            }

            .features {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                gap: 30px;
                margin-bottom: 60px;
            }

            .feature-card {
                background: white;
                border-radius: 12px;
                padding: 30px;
                box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
                transition: transform 0.3s ease, box-shadow 0.3s ease;
            }

            .feature-card:hover {
                transform: translateY(-5px);
                box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
            }

            .feature-card h2 {
                color: #667eea;
                margin-bottom: 15px;
                font-size: 1.5rem;
            }

            .feature-card p {
                color: #666;
                line-height: 1.6;
            }


            @media (max-width: 768px) {
                .features {
                    grid-template-columns: 1fr;
                    gap: 20px;
                }
            }

        </style>

        <div class="features">
        <div class="feature-card">
            <h2>Inventory Management</h2>
            <p>Keep a complete record of all your home appliances easily by taking a photo of its manufacturers tag.</p>
        </div>

        <div class="feature-card">
            <h2>Warranty Tracking</h2>
            <p>Monitor warranty expiration dates and stay informed about coverage for each appliance.</p>
        </div>

        <div class="feature-card">
            <h2>Service History</h2>
            <p>Document repairs, maintenance, and service calls for your appliances over time.</p>
        </div>

        <div class="feature-card">
            <h2>Live Demo</h2>
            <p>
                <hat-nav-button href="/app" title="demo">Try it out!</hat-nav-button>
            </p>
        </div>            
        </div>
    `;
  }
}

customElements.define("hat-welcome", HatWelcome);